import fetchJsonp from 'fetch-jsonp';
import { toQueryString } from '../../utils/UrlUtil';
import { mapProviderInfo } from '../constants/index';

const { baiduKey } = mapProviderInfo.baidu;

var BaiduConvertService = function() {};

BaiduConvertService.prototype = Object.create(BaiduConvertService.prototype);
BaiduConvertService.prototype.constructor = BaiduConvertService;

BaiduConvertService.prototype.fetch = function fetchBaidu(options, context) {
    var inputPoints = options.inputPoints;
    var size = inputPoints.length;
    var numOfPntPerRequest = 20;
    var xAry = [];
    var yAry = [];
    var hasError = false;
    var group = [];
    var requestMade = 0;
    var callbackSent = false;
    var numberOfGroup = Math.ceil(inputPoints.length / numOfPntPerRequest);
    inputPoints.forEach(function(point, index) {
        xAry.push(Number(point.longitude));
        yAry.push(Number(point.latitude));
        var _index = index + 1;
        if (_index % numOfPntPerRequest == 0 || _index == size) {
            var groupIndex = Math.ceil(_index / numOfPntPerRequest) - 1;
            var url =
                'https://sapi.map.baidu.com/ag/coord/convert?v=2.0&ak=KQMz9KcIzBwWNUgbHWUHZGSD&s=1&from=' +
                0 +
                '&to=' +
                4 +
                '&x=' +
                xAry.join() +
                '&y=' +
                yAry.join() +
                '&mode=1';
            fetchJsonp(url, {
                headers: { Accept: 'application/json' },
                jsonCallbackFunction: 'showLocation'
            })
                .then((response) => response.json())
                .then((jsonResponse) => {
                    let convertedPoints = [];
                    jsonResponse.forEach(function(encodedPoint) {
                        if (encodedPoint.error == 0) {
                            let decodedX = Number(window.atob(encodedPoint.x));
                            let decodedY = Number(window.atob(encodedPoint.y));
                            convertedPoints.push({ lat: decodedY, lng: decodedX });
                        } else {
                            hasError = true;
                        }
                    });
                    partialReady(groupIndex, convertedPoints);
                });
            xAry.length = 0;
            yAry.length = 0;
        }
    });

    var allReady = function() {
        if (!hasError) {
            var rtnPoints = [];
            for (var i = 0; i < group.length; i++) {
                for (var j = 0; j < group[i].length; j++) {
                    rtnPoints.push(group[i][j]);
                }
            }
            options.success.call(context, { points: rtnPoints });
        } else if (!callbackSent) {
            options.success.call(context, { points: rtnPoints });
        } else {
            /* do nothing */
        }
    };
    var partialReady = function(groupIndex, convertedPoints) {
        group[groupIndex] = convertedPoints;
        requestMade++;
        if (requestMade == numberOfGroup || hasError) {
            allReady();
        }
    };
};

BaiduConvertService.prototype.fetchGenerator = function*(points, isGcj02 = false) {
    let finalResponse = [];
    let start = 0;
    let end = 0;
    const convertLimit = 20;
    let pointsLeft = points.length;
    while (pointsLeft > 0) {
        let xAry = [];
        let yAry = [];
        let convertNum = pointsLeft >= convertLimit ? convertLimit : pointsLeft;
        start = end;
        end = start + convertNum;
        pointsLeft -= convertNum;

        let inputPoints = points.slice(start, end);
        inputPoints.forEach((point) => {
            xAry.push(Number(point.longitude || point.lon));
            yAry.push(Number(point.latitude || point.lat));
        });

        const queryParams = toQueryString({
            v: '2.0',
            ak: baiduKey,
            s: 1,
            from: isGcj02 ? 2 : 0,
            to: 4,
            x: xAry.join(),
            y: yAry.join(),
            mode: 1
        });

        const url = `https://sapi.map.baidu.com/ag/coord/convert${queryParams}`;

        const response = yield fetchJsonp(url, {
            headers: { Accept: 'application/json' },
            jsonCallbackFunction: 'showLocation'
        });
        const jsonResponse = yield response.json();
        let decodedPoints = [];
        jsonResponse.forEach((encodedPoint) => {
            if (encodedPoint.error === 0) {
                let decodedX = Number(window.atob(encodedPoint.x));
                let decodedY = Number(window.atob(encodedPoint.y));
                decodedPoints.push({ lat: decodedY, lon: decodedX });
            } else {
                throw 'Baidu coordinates convertion error on fetchGenerator';
            }
        });
        finalResponse.push(...decodedPoints);
    }
    return finalResponse;
};

export default BaiduConvertService;
